import { useMemo } from 'react';
import { getCspNonce } from './cspNonce';

/**
 * React hook to get the CSP nonce value.
 * The nonce is memoized to avoid re-reading from the DOM on every render.
 * 
 * @returns The CSP nonce value, or null if not found
 * 
 * @example
 * ```tsx
 * function MyComponent() {
 *   const nonce = useCspNonce();
 *   
 *   useEffect(() => {
 *     if (nonce) {
 *       const style = document.createElement('style');
 *       style.setAttribute('nonce', nonce);
 *       style.textContent = 'body { color: red; }';
 *       document.head.appendChild(style);
 *     }
 *   }, [nonce]);
 * }
 * ```
 */
export function useCspNonce(): string | null {
    return useMemo(() => getCspNonce(), []);
}
